import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedHTMLMessage } from 'react-intl'
import { Note, CenteredContent, CircleBadge, Title } from 'components/misc'
import { ElevatedButton } from 'components/layout'
import { apiDashboard } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'

@apiDashboard.apiAwards()
@form({
  form: 'startNewLevel',
  disableHook: true,
})
class AwardCompleted extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    onStartNewLevel: PropTypes.func,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    awardId: PropTypes.number,
    intlValues: PropTypes.object,
  }

  handleSubmit = () => this.props.onStartNewLevel(this.props.awardId, { resetForm: this.props.reset })
    .then(res => {
      if (__CLIENT__ && get(res, 'body.value')) {
        // window.open(get(res, 'body.value'), '_blank')
        window.location = get(res, 'body.value')
      }
    })

  render() {
    const {
      loading,
      handleSubmit,
      intlValues,
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <CenteredContent marginAuto>
          <CircleBadge defaultColor large medal>
            <i className='ico ico--icon-award' />
          </CircleBadge>
        </CenteredContent>

        <Title defaultColor h2 style={{ textAlign: 'center', paddingTop: '10px' }}>
          <FormattedHTMLMessage id='moduleTitle.award_completed' defaultMessage='Award completed!' />
        </Title>

        <Note margin='20px 0 30px'>
          <FormattedHTMLMessage
            id='label.congratulation_your_award_has_been_approved'
            defaultMessage='Congratulation. Your award has been approved! <br /> If you want, you can already start new level.'
            values={intlValues}
          />
        </Note>

        <ElevatedButton
          uppercase rounded submit padded fullWidth
          isLoading={loading}
          intlKey='button.start_new_level'
        >
          Start new level
        </ElevatedButton>
      </form>
    )
  }
}

export default AwardCompleted
